import { LoadingDots } from '../../../core'
import { styled } from '../../../styles'
import { BaseThemeType, useMediaQuery } from '../../../theme'
import { CheckoutFinancingPricingOption, CheckoutFinancingPricingParams, LenderType } from '../types'
import FinanceMarketplaceSummary from './FinanceMarketplaceSummary'
import MarketplacePricingOptionRows from './MarketplacePricingOptionRows'

type PropTypes = {
  pricingOptions: CheckoutFinancingPricingOption[]
  lenders: LenderType[]
  isLoading: boolean
  translate: (text: string) => string
  updatePricingParams: (newParams: CheckoutFinancingPricingParams) => void
  pricingParams: CheckoutFinancingPricingParams
}

const MainWrapper = styled('div')<{ isMobile: boolean }>(({ isMobile }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  minHeight: '400px',
  minWidth: isMobile ? '200px' : '400px',
}))

const LoadingDotsWrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  opacity: 0.5,
}))

const FinanceMarketplaceDialogContent = (props: PropTypes) => {
  const { pricingOptions, translate, isLoading, pricingParams, updatePricingParams } = props

  const isMobile = useMediaQuery((theme: BaseThemeType) => theme.breakpoints.down('sm'))

  if (!pricingOptions.length && !isLoading)
    return (
      <div>
        <h2>{translate('No Payment Options Available')}</h2>
        <p>
          {translate(
            'No payment options are available for this system design. This often means the system does not meet lender requirements around system price or the installation address.'
          )}
        </p>
      </div>
    )
  return (
    <MainWrapper isMobile={isMobile}>
      <h1>{translate('Finance Marketplace')}</h1>
      <FinanceMarketplaceSummary pricingParams={pricingParams} updatePricingParams={updatePricingParams} />
      {isLoading && (
        <LoadingDotsWrapper>
          <LoadingDots />
        </LoadingDotsWrapper>
      )}
      {pricingOptions.map((pricingOption, i) => (
        <MarketplacePricingOptionRows key={pricingOption.total_repayable} pricingOption={pricingOption} />
      ))}
    </MainWrapper>
  )
}
export default FinanceMarketplaceDialogContent
